import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Template from '../../components/Template';
import i18n from '../../translate/i18n';

import './styles.css';


// ICONS
import { ReactComponent as DollarIcon } from '../../assets/icons/currency-dollar.svg';
import { ReactComponent as CreditCardIcon } from '../../assets/icons/credit-card.svg';

// COMPONENTS
import PlanosComponent from './Planos';
import FormasPagamento from './FormasPagamento';
import Pagamentos from './Pagamentos';
import Alert from '../../helpers/Alert';

interface TypeData {
  id: string,
  name: string;
  email: string;
  picture: string;
  branch: string;
  password: string;
}


export default function FinancialPage() {
  const [menuSelected, setMenuSelected] = useState('planos')

  return (
    <Template path={i18n.t('menu.financial')}>
      <div className='container'>
        <div className='col-md-12'>
          <div className='row'>
            <div className='col-md-3'>
              <div className='container-box'>
                <h5>{i18n.t<string>('menu.financial')}</h5>
                <hr />
                <ul className='menu-container-left'>
                  <li onClick={() => { setMenuSelected('planos') }} className={menuSelected === 'planos' ? 'menu-container-left-selected' : ''}>
                    <DollarIcon /> <p>Planos</p>
                  </li>
                  <li onClick={() => { setMenuSelected('pagamentos') }} className={menuSelected === 'pagamentos' ? 'menu-container-left-selected' : ''}>
                    <DollarIcon /> <p>Pagamentos</p>
                  </li>
                  {/*<li onClick={() => { setMenuSelected('formas_pagamento') }} className={menuSelected === 'formas_pagamento' ? 'menu-container-left-selected' : ''}>
                    <CreditCardIcon /> <p>Formas de pagamento</p></li>*/}
                </ul>
              </div>
            </div>
            <div className='col-md-9'>
              {menuSelected === 'planos' && <PlanosComponent />}
              {menuSelected === 'pagamentos' && <Pagamentos />}
              {menuSelected === 'formas_pagamento' && <FormasPagamento />}
            </div>
          </div>
        </div>
      </div>
    </Template>
  )
}
